module.exports = __webpack_public_path__ + "static/img/8.8843aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v15_new_features/8.png
// module id = H2AX
// module chunks = 0